import {
    apiRequest,
    pangkatList,
    pangkatActive,
    pangkatInactive
} from "../../../../../services/adapters/kepegawaian/pangkatService"

class DataTableRepository {

    fetchRowTable = async (query, cancelToken) => {
        return await apiRequest("get", pangkatList, {
            cancelToken: cancelToken,
            params: query
        }, true)
    }

    fetchInactive = async (query) => {
        return await apiRequest("post", pangkatInactive, {
            body: query
        }, true)
    }

    fetchActive = async (query) => {
        return await apiRequest("post", pangkatActive, {
            body: query
        }, true)
    }
}

export default DataTableRepository